import styled from "styled-components";
import {h2Css, h3Css} from "@/styles/typography";
import { responsiveFontSize, responsiveFontSizeL } from "@/styles/global";

const CardHeaderWrapper = styled.div`
    width: 100%;
    text-align: center;
    color: ${({ theme }) => theme.colors.title};
    font-family: 
`;

const CardTitle = styled.h2`
    ${h2Css}
    ${responsiveFontSizeL}
    margin-top: 30px;
`;

const CardSubTitle = styled.h3`
    margin: 0;
    ${responsiveFontSize}
    font-weight: 400;
    color: #666;
    font-family: "Open Sans", sans-serif;
    margin-top: 5px;
`;

const S = {
    CardHeaderWrapper,
    CardTitle,  
    CardSubTitle,
};

export default S;
